import React from "react";
import { Box, Divider, GridItem, SimpleGrid, Text, useColorModeValue } from "@chakra-ui/react";

interface MetadataGridProps {
  recipientName?: string;
  certificateType?: string;
  issueDate?: string;
  participantId?: string;
  programName?: string;
  organizationName?: string;
}

const DetailField: React.FC<{ label: string; value?: string }> = ({ label, value }) => {
  const labelColor = useColorModeValue("gray.500", "gray.400");
  const valueColor = useColorModeValue("gray.800", "gray.100");
  return (
    <Box minW="0">
      <Text fontSize="xs" fontWeight="semibold" color={labelColor} textTransform="uppercase" letterSpacing="wide" mb={1}>
        {label}
      </Text>
      <Text fontSize="md" fontWeight="semibold" color={valueColor} wordBreak="break-word">
        {value || "N/A"}
      </Text>
    </Box>
  );
};

// Row 1: Recipient, Type, Format, Issue Date — Row 2: Participant ID, Program, Issued By
export const MetadataGrid: React.FC<MetadataGridProps> = ({
  recipientName,
  certificateType,
  issueDate,
  participantId,
  programName,
  organizationName,
}) => {
  const cardBg = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const headingColor = useColorModeValue("gray.800", "gray.100");

  return (
    <Box bg={cardBg} borderWidth={1} borderColor={borderColor} rounded="xl" shadow="sm" p={{ base: 4, md: 6 }} w="100%">
      <Text fontSize="lg" fontWeight="bold" color={headingColor} mb={5}>
        Credential details
      </Text>

      <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacingX={6} spacingY={5}>
        <DetailField label="Recipient" value={recipientName} />
        <DetailField label="Type" value={certificateType} />
        <DetailField label="Format" value="Virtual" />
        <DetailField label="Issue Date" value={issueDate} />
      </SimpleGrid>

      <Divider my={5} borderColor={borderColor} />

      <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacingX={6} spacingY={5}>
        <DetailField label="Participant ID" value={participantId} />
        <GridItem colSpan={{ base: 1, sm: 2, md: 1 }} order={{ base: 0, sm: 3, md: 0 }}>
          <DetailField label="Program / Event Name" value={programName} />
        </GridItem>
        <DetailField label="Issued By" value={organizationName} />
      </SimpleGrid>
    </Box>
  );
};
